import { render, staticRenderFns } from "./player-avatar.vue?vue&type=template&id=c22e39dc&"
import script from "./player-avatar.vue?vue&type=script&lang=js&"
export * from "./player-avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports